import { gql } from "@apollo/client";

export const BLOGS_QUERY = gql`
  query Blogs {
    blogs(admin: false) {
      id
      title
      slug
      excerpt
      coverImage
      publishedAt
    }
  }
`;

export const BLOG_QUERY = gql`
  query Blog($slug: String!) {
    blog(slug: $slug) {
      title
      excerpt
      content
      coverImage
      publishedAt
    }
  }
`;
